import React, { useEffect, useState } from 'react'
import { ButtonGroup, ToggleButton } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { useLazyGetDevicesQuery } from '../../../api/deviceApiSlice';
import Block from '../../../components/Block';
import Pagination from '../../../components/tables/Pagination';
import Table from '../../../components/tables/Table';
import useAsyncTable from '../../../components/tables/useAsyncTable';
import Title from '../../../components/Title';
import {OsIcon} from "../../../components/OsIcon";

const DevicesList = () => {
  const [devicesList] = useLazyGetDevicesQuery()
  const { t } = useTranslation();
  const history = useHistory();
  const { search } = useLocation();
  const getSearchMonitor = () => {
    return JSON.parse(new URLSearchParams(search).get("monitored"))
  }
  const [monitored, setMonitored] = useState(getSearchMonitor())
  useEffect(() => {
    const params = new URLSearchParams(search)
    if (monitored) {
      params.set("monitored", 'true')
    } else {
      params.delete("monitored")
    }
    history.push({search: params.toString()})
  }, [monitored])

  const hiddenColumns = monitored ? ["monitored"] : ["monitored", "comment"]

  const {
    tableProps,
    paginationProps,
    tableFilterProps
  } = useAsyncTable({
    sortable: true,
    paginate: true,
    hiddenColumns: hiddenColumns,
    initialFilters: [{id: "monitored", value: monitored}],
    sortBy: {id: 'desc'},
    callback: devicesList
  })
  const { setFilter } = tableFilterProps;

  const columns = [
    {
      Header: 'Id',
      accessor: 'id',
      disableFilters: true,
      headerStyle: {verticalAlign: "baseline"}
    },
    {
      Header: 'MAID',
      accessor: 'idfa',
      disableFilters: false
    },
    {
      Header: 'SPT id',
      accessor: 'spt_id',
      disableFilters: false
    },
    {
      Header: 'OS',
      Cell: ({row}) => (row.original.os ? <OsIcon style={{fontSize: "20px"}} os={row.original.os}/> : <></>),
      accessor: 'os',
      filter: 'select',
      options: ["ios", "android"],
      disableFilters: false
    },
    {
      Header: 'Active',
      Cell: ({row}) => (row.original.active ? "true" : "false"),
      accessor: 'active',
      filter: 'select',
      options: [
        {label: "active", value: true},
        {label: "inactive", value: false},
      ],
      disableFilters: false
    },
    {
      Header: 'Application',
      accessor: 'bundle_id',
      disableFilters: false
    },
    {
      Header: 'Created at',
      accessor: 'created_at',
      format: 'date',
      formatOptions: {dateFormat: "longShortMonth"},
      headerStyle: {verticalAlign: "baseline"}
    },
    {
      Header: 'Comment',
      accessor: 'comment',
      disableFilters: true
    },
    {
      Header: 'Monitored',
      accessor: 'monitored',
      disableFilters: true
    }
  ];

  const onRowClick = (data) => {
    history.push(`/devices/${data.spt_id}`);
  }

  useEffect(() => {
    setFilter && setFilter('monitored', monitored)
  }, [monitored])

  return ( <>
    <Title main={t("menu.devices")} sub={ monitored ? `(${t("devices.monitored")})` : ''}>
      <ButtonGroup toggle className="mb-2">
        <ToggleButton
            type="checkbox"
            variant="secondary"
            checked={monitored}
            onChange={(e) => setMonitored(e.currentTarget.checked)}
          >
            {t("devices.monitored")}
        </ToggleButton>
      </ButtonGroup>
    </Title>
    <Block className="mb-0" style={{overflow: "initial"}}>
        <Table
          columns={columns}
          onRowClick={onRowClick}
          {...tableProps}/>
      </Block>
      <Pagination {...paginationProps}/>
  </> );
}
export default DevicesList;
